import { Grid } from '@mui/material';
import { ControlDiscriminator, ControlPresentation } from '../../../controls/agyle/triageControls';
import AgyleTextField from '../../ui/fields/agyleTextField';
import { useTheme } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { getConfig } from '../../../util/configUtil';

const MTSControls = ({ value, onChange, canEdit, isError, isSmall, noMargin = false, isTriage = true }) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const discriminatorDetails = value?.discriminator?.details;

    // Configs
    const customLabelPresentation = getConfig('modules.customLabels.triage.presentation');
    const seeAndTreatManchesterTriageMandatory = getConfig('seeAndTreatManchesterTriageMandatory', true);

    let style = {
        mb: 2,
        mt: 0.5,
    };
    if (noMargin) {
        style = {};
    }

    return (
        <>
            <Grid container direction="row" spacing={2} sx={style}>
                <Grid item xs={isSmall ? 12 : 6}>
                    <ControlPresentation
                        label={t(customLabelPresentation || 'Presentation')}
                        value={value.presentation}
                        disabled={!canEdit}
                        agyleRefresh
                        discriminator={value.discriminator}
                        error={!value.presentation && isError && (isTriage ? seeAndTreatManchesterTriageMandatory : true)}
                        onChange={(value) => {
                            onChange((pr) => ({
                                ...pr,
                                presentation: value,
                                discriminator: null,
                            }));
                        }}
                        size="large"
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Grid item xs={isSmall ? 12 : 6}>
                    <ControlDiscriminator
                        label={t('Discriminator')}
                        value={value.discriminator}
                        agyleRefresh
                        presentation={value.presentation}
                        disabled={!canEdit}
                        error={!value.discriminator && isError && (isTriage ? seeAndTreatManchesterTriageMandatory : true)}
                        onChange={(value) => {
                            onChange((pr) => ({ ...pr, discriminator: value }));
                        }}
                        size="large"
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>
            </Grid>

            {discriminatorDetails && (
                <Grid item xs={12} style={{ marginTop: noMargin ? 15 : 0 }}>
                    <AgyleTextField
                        disabled
                        fullWidth
                        style={{ width: '100%' }}
                        label="Discriminator description"
                        type="string"
                        value={discriminatorDetails}
                        variant="outlined"
                        multiline
                        sx={{
                            '& .MuiInputBase-input.Mui-disabled': {
                                cursor: 'text',
                                pointerEvents: 'auto',
                                WebkitTextFillColor: theme.palette.mode !== 'light' ? 'white' : 'black',
                            },
                            '& .MuiFormLabel-root.MuiInputLabel-root.Mui-disabled': {
                                WebkitTextFillColor: theme.palette.mode !== 'light' ? 'rgba(255, 255, 255, 0.7)' : 'black',
                            },
                        }}
                        size="large"
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>
            )}
        </>
    );
};

export default MTSControls;
